import { useMemo } from 'react';

import useUpdates from 'modules/home/pages/hooks/useUpdates';

const useNotificationCount = () => {
  const { updates } = useUpdates();

  const notificationLength = useMemo(() => {
    return updates.filter((update) => update.type === 'event').length;
  }, [updates]);

  return notificationLength;
};

export default useNotificationCount;
